<script src="../app.routing.ts"></script>

<div class="" [class.hidden]="preLoader" style="
    width: 100%;
    text-align: center;
    height: 100%;
    position: fixed;
    padding-top: 40vh;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.94);
  ">
  <img *ngIf="brand.id" class="animated infinite pulse" [src]="brand.logoPath" style="width: 150px" />
</div>

<div class="menubar-hoverable header-fixed menubar-pin" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  ">
  <!-- header -->
  <!--  -->

  <!-- BEGIN BASE-->
  <div id="base">
    <div class="hide" id="load_new_admissions"></div>
    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas"></div>
    <!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->

    <!-- BEGIN CONTENT-->
    <div id="content">
      <section>
        <div class="section-body">
          <div class="row matrices">
            <!-- BEGIN ALERT - VISITS -->
            <div class="col-md-3 col-sm-6">
              <div class="card">
                <div class="card-body no-padding">
                  <div class="alert alert-callout alert-warning no-margin">
                    <strong class="pull-right text-lg" style="
                        position: relative;
                        margin-top: -2em;
                        background: #ff9800;
                        color: white;
                        padding: 10px 15px;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                      "><i class="md md-account-child"></i></strong>
                    <p class="opacity-50">{{ 'totalStudents' | translate }}</p>
                    <app-loader data="" loadingStyle="Dots" *ngIf="totalStudents === undefined"></app-loader>
                    <strong *ngIf="totalStudents !== undefined" class="text-xl">{{ totalStudents }}</strong>
                    <p *ngIf="permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED'" [routerLink]="['/groups']" class=""
                      style="
                        margin: 0;
                        border-top: 1px solid #f1f1f1;
                        text-align: right;
                        color: #8c8c8c;
                        cursor: pointer;
                      ">
                      <i class="md md-swap-horiz" style="margin: 0; line-height: 1; color: #ff9800"></i>
                      {{ 'viewDetails' | translate }}
                    </p>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END ALERT - VISITS -->

            <!-- BEGIN ALERT - REVENUE -->
            <div class="col-md-3 col-sm-6">
              <div class="card">
                <div class="card-body no-padding">
                  <div class="alert alert-callout alert-info no-margin">
                    <strong class="pull-right text-lg" style="
                        position: relative;
                        margin-top: -2em;
                        background: #26c6da;
                        color: white;
                        padding: 10px 15px;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                      "><i class="md md-speaker-notes"></i></strong>
                    <p class="opacity-50">{{ 'broadcastMade' | translate }}</p>
                    <app-loader data="" loadingStyle="Dots" *ngIf="totalBroadcast === undefined"></app-loader>
                    <strong class="text-xl" *ngIf="totalBroadcast !== undefined">{{ totalBroadcast }}</strong>
                    <p class="" style="
                        margin: 0;
                        border-top: 1px solid #f1f1f1;
                        text-align: right;
                        color: #8c8c8c;
                      ">
                      <i class="md md-swap-horiz" style="margin: 0; line-height: 1; color: #26c6da"></i>
                      {{ 'viewDetails' | translate }}
                    </p>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END ALERT - REVENUE -->

            <!-- BEGIN ALERT - BOUNCE RATES -->
            <div class="col-md-3 col-sm-6">
              <div class="card">
                <div class="card-body no-padding">
                  <div class="alert alert-callout alert-danger no-margin">
                    <strong class="pull-right text-lg" style="
                        position: relative;
                        margin-top: -2em;
                        background: #f44336;
                        color: white;
                        padding: 10px 15px;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                      "><i class="md md-thumbs-up-down"></i></strong>
                    <p class="opacity-50">{{ 'totalStaffs' | translate }}</p>
                    <app-loader data="" loadingStyle="Dots" *ngIf="totalStaffs === undefined"></app-loader>
                    <strong class="text-xl" *ngIf="totalStaffs !== undefined">{{
                      totalStaffs
                      }}</strong>
                    <p *ngIf="permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED'"
                      (click)="navigateTo('groups', 'staffs')" class="" style="
                        cursor: pointer;
                        margin: 0;
                        border-top: 1px solid #f1f1f1;
                        text-align: right;
                        color: #8c8c8c;
                      ">
                      <i class="md md-swap-horiz" style="margin: 0; line-height: 1; color: #f44336"></i>
                      {{ 'viewDetails' | translate }}
                    </p>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END ALERT - BOUNCE RATES -->

            <!-- BEGIN ALERT - BOUNCE RATES -->
            <div class="col-md-3 col-sm-6">
              <div class="card">
                <div class="card-body no-padding">
                  <div class="alert alert-callout alert-success no-margin">
                    <strong class="pull-right text-lg" style="
                        position: relative;
                        margin-top: -2em;
                        background: #4caf50;
                        color: white;
                        padding: 10px 15px;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                      "><i class="md md-content-paste"></i></strong>
                    <p class="opacity-50">{{ 'classes' | translate }}</p>
                    <app-loader data="" loadingStyle="Dots" *ngIf="totalClasses === undefined"></app-loader>
                    <strong class="text-xl" *ngIf="totalClasses !== undefined">{{ totalClasses }}</strong>
                    <p *ngIf="permissions.CLASS_MANAGEMENT == 'ENABLED'" [routerLink]="['/class']" class="" style="
                        cursor: pointer;
                        margin: 0;
                        border-top: 1px solid #f1f1f1;
                        text-align: right;
                        color: #8c8c8c;
                      ">
                      <i class="md md-swap-horiz" style="margin: 0; line-height: 1; color: #4caf50"></i>
                      {{ 'viewDetails' | translate }}
                    </p>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END ALERT - BOUNCE RATES -->
          </div>
          <!--end .row -->

          <div class="row card" style="margin: 0">
            <div class="col-md-12" style="padding: 0px; text-align: center; background: #f9f9f9">
              <h4 class="lead" style="margin: 0; display: inline-block">
                <span style="font-size: 2em"><i class="fa fa-mortar-board"></i></span>{{ getSchoolName
                }}<span style="font-size: 15px; color: #ff9800">
                  <!-- <i class="fa fa-star" aria-hidden="true"></i>
              <i class="fa fa-star" aria-hidden="true"></i>
              <i class="fa fa-star" aria-hidden="true"></i>
              <i class="fa fa-star" aria-hidden="true"></i>
              <i class="fa fa-star" aria-hidden="true"></i>-->
                </span>
              </h4>
              <p style="line-height: 0; color: #ffffff; font-weight: 400">
                <span style="
                    font-weight: 400;
                    background: #ff9800;
                    color: white;
                    display: inline-block;
                    line-height: 15px;
                    padding: 0px 5px;
                    font-size: 10px;
                  ">{{ accountType }} {{ 'account' | translate }}</span>
              </p>
              <!-- <p style="margin: -10px 55px;color: #8c8c8c;">Bangalore, Karnataka</p> -->

              <!-- <div class="col-md-12" style="text-align:right;margin: 0;margin-top: 15px;border-top: 1px solid #f1f1f1;">
                                <p class="" style="margin: 0;text-align: right;padding-top: 5px;color: #2b323a;cursor: pointer;display: inline-block;"><i class="fa fa-gears" style="margin: 0;line-height: 1;color: #2b323a;"></i> Settings</p>
                            </div> -->
            </div>
          </div>

          <div class="row card" style="margin: 0">
            <div class="col-md-12">
              <div class="col-md-12" >
                <div class="card-head">
                  <ul class="nav nav-tabs tabs-center" data-toggle="tabs" style="border-bottom: none">
                    <li *ngIf="permissions.VIEW_NEW_ADMISSIONS == 'ENABLED'" class="active">
                      <a data-target="#first1" data-toggle="tab" style="cursor: pointer">{{ 'newAdmissions' | translate }}</a>
                    </li>
                    <li *ngIf="permissions.VIEW_SCHOOL_DAY_STATUS == 'ENABLED'">
                      <a (click)="getSchoolActivityStatus()" data-target="#second1" data-toggle="tab"
                        style="cursor: pointer">{{ 'dailySchoolStatus' | translate }}</a>
                    </li>
                    <li *ngIf="onlinePaymentHistory == 'ENABLED'">
                      <a (click)="getOnlineFeePayCollection(null)" data-target="#third1" data-toggle="tab"
                        style="cursor: pointer">{{ 'onlinePayments' | translate }}</a>
                    </li>
                    <li>
                      <a data-target="#fourth1" data-toggle="tab" style="cursor: pointer">{{ 'bluewingsAppStatus' | translate:{ brandName: brand.name } }}</a>
                    </li>
                  </ul>
                  <!-- <header style="padding: 0;color: #7d7d7d;font-weight: 100;"><span style="background: #ababab;color: #ffffff;padding: 15px 10px 15px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;font-weight: 100;"><i class="fa fa-file-text-o" style="margin: 0;"></i></span> Activities</header> -->
                </div>
                <!--end .card-head -->
                <div class="card-body tab-content" style="padding: 20px 0px">
                  <div class="tab-pane active" id="first1">
                    <div class="row">
                      <div class="col-md-12" style="text-align: center">
                        <!-- <div class="" style="text-align: right;margin-top: 20px;display: inline-block;">
                                                    <h5 style="font-size: 15px;font-weight: 400;">Sort by date range:  </h5>
                                                </div> -->

                        <div class="col-md-12 zed-index-none" style="
                            border: 1px solid #ececec;
                            padding: 10px 0px;
                            background: #fbfbfb;
                          ">
                          <div>
                            <h4 >{{ 'listOfNewAdmissions' | translate }}</h4>

                            <label class="radio-inline radio-styled zed-index-0">
                              <input type="radio" name="new-admission" id="new-admissions-all" checked
                                (click)="admissionByClick(true)" /><span style="font-size: 12px; color: #848484">{{ 'allNewAdmissions' | translate }}</span>
                            </label>
                            <label class="radio-inline radio-styled zed-index-0">
                              <input type="radio" name="new-admission" id="new-admissions-by-date" /><span
                                style="font-size: 12px; color: #848484" (click)="admissionByClick(false)">{{ 'newAdmissionByDate' | translate }}</span>
                            </label>
                          </div>
                        </div>

                        <form class="form"  *ngIf="!admissionByStatus">
                          <div class="form-group" style="display: inline-block">
                            <h5 style="
                                font-size: 13px;
                                font-weight: 400;
                                color: #8e8e8e;
                              ">
                              {{ 'newAdmissionByDateLabel' | translate }}        
                            </h5>
                          </div>
                          <div class="form-group" style="display: inline-block">
                            <input type="text" class="form-control getAdmissionDateBy applyPicker" style="
                                text-transform: initial;
                                border: none;
                                color: #2b323a;
                                border-bottom: 1px solid gainsboro;
                              " data-provide="datepicker" data-date-format="yyyy/mm/dd" />
                            <!-- <label for="admission-dob">From<span style="color: #F44336;">* </span> (mm/dd/yyyy )</label> -->
                          </div>
                          <div class="" style="display: inline-block">
                            <button (click)="viewAdmissionByDate()" type="button"
                              class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false"
                              style="
                                background: var(--select-bg-color);
                                border: none;
                                margin-top: 5px;
                                padding: 3px 15px;
                                font-size: 12px;
                              ">
                              {{ 'viewAdmissions' | translate }}
                              <!-- <i class="fa fa-caret-down text-default-light"></i> -->
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="row" style="min-height: 400px">
                      <div *ngIf="loaderadmission" style="
                          position: absolute;
                          width: 100%;
                          height: 100%;
                          left: 0;
                          background: white;
                          padding-bottom: 8em;
                        ">
                        <div class="col-md-12" style="text-align: center; margin-top: 2.5em">
                          <img src="../../assets/img/search_icon_animation.gif" style="width: 300px" />
                          <h3 style="
                              margin: 0;
                              margin-top: -2em;
                              color: #a1a1a1;
                              font-weight: 400;
                            ">
                            {{ 'pleaseWait' | translate }}
                          </h3>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <form *ngIf="admissionByStatus" class="form-inline text-center search-groups"
                          autocomplete="off">
                          <div class="form-group">
                            <h4 style="color: #6b6b6b; font-weight: 300">
                              {{'filterStudentsBy' | translate}}
                            </h4>
                          </div>
                          <div class="form-group">
                            <select id="category-id" name="select13" class="form-control" style="
                                text-transform: uppercase;
                                border-bottom: 1px solid;
                              " (change)="
                                getCategoryFunction($event.target.value)
                              ">
                              <option value="0">{{ 'allCategories' | translate }}</option>
                              <option *ngFor="let category of schoolCategories" value="{{ category.categoryId }}">
                                {{ category.categoryName }}
                              </option>
                            </select>
                            <div class="form-control-line"></div>
                          </div>
                          <div class="form-group">
                            <select id="class-id" name="select13" class="form-control" style="
                                text-transform: uppercase;
                                border-bottom: 1px solid;
                              " [disabled]="selectClassStatus" (change)="
                                selectClassFunction($event.target.value)
                              ">
                              <option value="0">{{ 'selectClass' | translate }}</option>
                              <option *ngFor="let cl of schoolClasses" value="{{ cl.classid }}">
                                {{ cl.classname }}
                              </option>
                            </select>
                            <div class="form-control-line"></div>
                          </div>
                          <div class="form-group">
                            <select id="section-id" name="select13" class="form-control" style="
                                text-transform: uppercase;
                                border-bottom: 1px solid;
                              " [disabled]="selectClassSectionStatus" (change)="
                                selectSectionFunction($event.target.value)
                              ">
                              <option value="0">{{ 'selectSection' | translate }}</option>
                              <option *ngFor="let section of schoolClassesSections" value="{{ section.claaSectionId }}">
                                {{ section.classSection }}
                              </option>
                            </select>
                            <div class="form-control-line"></div>
                          </div>
                        </form>
                      </div>
                      <div *ngIf="noresultadmission" class="col-md-12" style="
                          text-align: center;
                          background-size: contain;
                          background-position: -10px 4px;
                          color: #909090;
                        ">
                        <div class="col-md-12" style="min-height: 300px; padding-top: 4em">
                          <h1 style="font-size: 4em">
                            <i class="fa fa-file-excel-o"></i>
                          </h1>
                          <h3>{{ 'noResults' | translate }}</h3>
                          <!--<p>We search for and wide and could'nt<br>find any files matching</p>-->
                        </div>
                      </div>
                      <div class="col-lg-12" *ngIf="!noresultadmission">
                        <div class="table-responsive" style="margin-top: 2em">
                          <table id="new-admission-table" class="display" cellspacing="0" width="100%">
                            <thead>
                             <tr>
                              <th style="padding-left: 15px">{{ 'student' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'studentClass' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'dateOfAdmission' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'admissionNo' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'father' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'mother' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'dateOfBirth' | translate }}</th>
                              <th style="padding-left: 15px">{{ 'phone' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let student of getNewAdmissionListArray" class="gradeX">
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.studentName }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.classNumber }}-{{
                                  student.classDivision
                                  }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{
                                  student.dateOfAdmission
                                  | date : "MMM dd, yyyy"
                                  }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.registrationId }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.parentName }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.motherName || "" }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{
                                  student.dateOfBirth | date : "MMM dd, yyyy"
                                  }}
                                </th>
                                <th style="font-weight: 400; color: #828282">
                                  {{ student.mobileNumber }}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!--end .table-responsive -->
                      </div>
                      <!--end .col -->
                    </div>
                    <!--end .row -->
                  </div>

                  <!-- School activities -->
                  <div class="tab-pane" id="second1">
                    <div class="row">
                      <div class="col-md-12" style="text-align: center">
                        <div class="col-md-12" style="
                            border: 1px solid #ececec;
                            padding: 10px 0px;
                            background: #fbfbfb;
                            padding-bottom: 0px;
                            margin-bottom: 2em;
                          ">
                          <div>
                            <h4 style="margin-bottom: 0px">
                                {{ 'listOfSchoolActivities' | translate }}
                            </h4>
                            <form class="form ng-untouched ng-pristine ng-valid" style="padding-top: 5px">
                              <div class="form-group" style="display: inline-block; padding: 0">
                                <h5 style="
                                    font-size: 13px;
                                    font-weight: 400;
                                    color: #8e8e8e;
                                  ">
                                  {{ 'activitiesByDate' | translate }}:
                                </h5>
                              </div>

                              <div class="form-group" style="display: inline-block; padding: 0">
                                <input class="form-control getstatusdate applyPicker" data-date-format="yyyy/mm/dd"
                                  data-provide="datepicker" style="
                                    text-transform: initial;
                                    border: none;
                                    color: #868686;
                                    border-bottom: 1px solid gainsboro;
                                  " type="text" value="{{ todayDate }}" />
                              </div>

                              <div class="" style="display: inline-block">
                                <button (click)="viewSchoolActivityByDate()" aria-expanded="false"
                                  class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" style="
                                    background: var(--select-bg-color);
                                    border: none;
                                    margin-top: 5px;
                                    padding: 3px 15px;
                                    font-size: 12px;
                                  " type="button">
                                  {{ 'viewActivities' | translate }}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="min-height: 400px; padding: 0em 1em">
                      <div *ngIf="loaderactivity" style="
                          position: absolute;
                          width: 100%;
                          height: 100%;
                          left: 0;
                          background: white;
                          padding-bottom: 8em;
                          z-index: 999;
                        ">
                        <div class="col-md-12" style="text-align: center">
                          <img src="../../assets/img/search_icon_animation.gif" style="width: 300px" />
                          <h3 style="
                              margin: 0;
                              margin-top: -2em;
                              color: #a1a1a1;
                              font-weight: 400;
                            ">
                             {{ 'pleaseWait' | translate }}
                          </h3>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <table id="school-activity-table" class="display" cellspacing="0" width="100%">
                          <thead>
                           <tr>
                            <th style="padding-left: 15px">{{ 'className' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'classTeachers' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'attendance' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'conversations' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'activityPosted' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'diaries' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'feesCollection' | translate }} ({{ schoolCurrency }})</th>
                            <th style="padding-left: 15px">{{ 'totalStudents' | translate }}</th>
                            <th style="padding-left: 15px">{{ 'activeParents' | translate }}</th>
                          </tr>
                          </thead>

                          <tbody>
                            <tr (click)="
                                viewActivityDetail(
                                  activity.classId,
                                  activity.classNumber,
                                  activity.classDivision,
                                  activity.totalStudents,
                                  activity.totalAttendanceCount,
                                  activity.feesCollection,
                                  activity.diaries,
                                  activity.classTeacherName,
                                  activity.secondClassTeacherName,
                                  activity.thirdClassTeacherName
                                )
                              " *ngFor="let activity of getSchoolStatusListArray" class="gradeX"
                              style="cursor: pointer">
                              <td style="font-weight: 400; color: #828282">
                                {{ activity.classNumber }}-{{
                                activity.classDivision
                                }}
                              </td>
                              <td style="font-weight: 400; color: #828282">
                                <div *ngIf="
                                    activity.classTeacherName &&
                                    activity.secondClassTeacherName &&
                                    activity.thirdClassTeacherName
                                      ? true
                                      : false
                                  ">
                                  {{ activity.classTeacherName }}<br />{{
                                  activity.secondClassTeacherName
                                  }}<br />{{ activity.thirdClassTeacherName }}
                                </div>
                                <div *ngIf="
                                    activity.classTeacherName &&
                                    activity.secondClassTeacherName &&
                                    activity.thirdClassTeacherName
                                      ? false
                                      : true
                                  " style="text-align: center">
                                  -
                                </div>
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                " #attendence>
                                {{ activity.totalAttendanceCount }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                ">
                                {{ activity.prentToStaffChat }}
                                <span><i class="fa fa-arrows-h"></i></span>
                                {{ activity.staffToPrentChat }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                ">
                                {{ activity.activityShared }} {{ 'activities' | translate }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                " #diaries>
                                {{ activity.diaries }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                " #fessCollected>
                                {{
                                activity.feesCollection
                                ? activity.feesCollection
                                : "-"
                                }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                " #totalStudents>
                                {{ activity.totalStudents }}
                              </td>
                              <td style="
                                  font-weight: 400;
                                  color: #828282;
                                  text-align: center;
                                ">
                                {{ activity.activeParents }}
                              </td>
                              <span style="display: none" #classId>{{
                                activity.classId
                                }}</span>
                              <span style="display: none" #teacher1>{{
                                activity.classTeacherName
                                }}</span>
                              <span style="display: none" #teacher2>{{
                                activity.secondClassTeacherName
                                }}</span>
                              <span style="display: none" #teacher3>{{
                                activity.thirdClassTeacherName
                                }}</span>
                            </tr>
                            <!-- <tr class="gradeX">
                        <td>Nursary A</td>
                        <td>Sandheep, Sudhakar</td>
                        <td>Not taken</td>
                        <td>None</td>
                        <td>None</td>
                        <td>None</td>
                        <td>None</td>
                        <td>30</td>
                        <td>10</td>
                      </tr>-->
                          </tbody>
                        </table>
                      </div>
                      <!--end .table-responsive -->
                    </div>
                  </div>
                  <!-- ////// -->

                  <div class="tab-pane" id="third1">
                    <div class="row">
                      <div class="col-md-12" style="text-align: center">
                        <div class="col-md-12" style="
                            border: 1px solid #ececec;
                            padding: 10px 0px;
                            background: #fbfbfb;
                          ">
                          <div>
                            <h4 >{{ 'onlinePaymentHistory' | translate }}</h4>

                            <label class="radio-inline radio-styled">
                              <input type="radio" name="gendre" checked (click)="paymentHistoryByClick(true)" /><span
                                style="font-size: 12px; color: #848484"> {{ 'paymentByDay' | translate }}</span>
                            </label>
                            <label class="radio-inline radio-styled">
                              <input type="radio" name="gendre" (click)="paymentHistoryByClick(false)" /><span
                                style="font-size: 12px; color: #848484">{{ 'paymentByDuration' | translate }}</span>
                            </label>
                          </div>
                        </div>

                        <form class="form" *ngIf="paymentHistoryByStatus">
                          <div class="form-group" style="display: inline-block">
                            <h5 style="
                                font-size: 13px;
                                font-weight: 400;
                                color: #8e8e8e;
                              ">
                              {{ 'selectDate' | translate }}
                            </h5>
                          </div>
                          <div class="form-group" style="display: inline-block">
                            <input type="text" class="form-control applyPicker" id="online_fee_col_st1" style="
                                text-transform: initial;
                                border: none;
                                color: #868686;
                                border-bottom: 1px solid gainsboro;
                              " data-provide="datepicker" data-date-format="dd/mm/yyyy" />
                            <!-- <label for="admission-dob">From<span style="color: #F44336;">* </span> (mm/dd/yyyy )</label> -->
                          </div>

                          <div class="" style="display: inline-block">
                            <button type="button" (click)="
                                getOnlineFeePayCollection(
                                  paymentHistoryByStatus
                                )
                              " class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown"
                              aria-expanded="false" style="
                                background: var(--select-bg-color);
                                border: none;
                                margin-top: 5px;
                                padding: 3px 15px;
                                font-size: 12px;
                              ">
                              {{ 'viewDetails' | translate }}
                              <!-- <i class="fa fa-caret-down text-default-light"></i> -->
                            </button>
                          </div>
                        </form>

                        <form class="form" *ngIf="!paymentHistoryByStatus">
                          <div class="form-group" style="display: inline-block">
                            <h5 style="
                                font-size: 13px;
                                font-weight: 400;
                                color: #8e8e8e;
                              ">
                              {{ 'from' | translate }}
                            </h5>
                          </div>

                          <div class="form-group" style="display: inline-block">
                            <input type="text" class="form-control applyPicker" id="online_fee_col_st2" style="
                                text-transform: initial;
                                border: none;
                                color: #868686;
                                border-bottom: 1px solid gainsboro;
                              " data-provide="datepicker" data-date-format="dd/mm/yyyy" />
                            <!-- <label for="admission-dob">From<span style="color: #F44336;">* </span> (mm/dd/yyyy )</label> -->
                          </div>

                          <div class="form-group" style="display: inline-block">
                            <h5 style="color: #a7a7a7">{{ 'to' | translate }}</h5>
                          </div>

                          <div class="form-group" style="display: inline-block">
                            <input type="text" class="form-control applyPicker" id="online_fee_col_end" style="
                                text-transform: initial;
                                border: none;
                                color: #868686;
                                border-bottom: 1px solid gainsboro;
                              " data-provide="datepicker" data-date-format="dd/mm/yyyy" />
                            <!-- <label for="admission-dob">From<span style="color: #F44336;">* </span> (mm/dd/yyyy )</label> -->
                          </div>

                          <div class="" style="display: inline-block">
                            <button type="button" (click)="
                                getOnlineFeePayCollection(
                                  paymentHistoryByStatus
                                )
                              " class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown"
                              aria-expanded="false" style="
                                background: var(--select-bg-color);
                                border: none;
                                margin-top: 5px;
                                padding: 3px 15px;
                                font-size: 12px;
                              ">
                              {{ 'viewDetails' | translate }}
                              <!-- <i class="fa fa-caret-down text-default-light"></i> -->
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>

                    <!-- <div class="row" *ngIf="onlineFeeCollection.length == 0">
                    <div class="col-md-12" style="text-align: center;background: url('assets/img/noresult.jpg');background-size: contain;background-position: -10px 4px;color: #909090;">
                      <div class="col-md-12" style="min-height: 300px;padding-top: 4em;">
                        <h1 style="font-size: 4em;"><i class="fa fa-file-excel-o"></i></h1>
                        <h3>No Results</h3>
                        <p>We search for and wide and could'nt<br>find any files matching</p>
                      </div>
                    </div>
                  </div>
-->
                    <div class="table-responsive" style="margin-top: 2em">
                      <table id="onlineFeeCollectionTable" class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>{{ 'studentName' | translate }}</th>
                            <th>{{ 'registrationId' | translate }}</th>
                            <th>{{ 'parent' | translate }}</th>
                            <th>{{ 'class' | translate }}</th>
                            <th>{{ 'amount' | translate }}</th>
                            <th>{{ 'purpose' | translate }}</th>
                            <th>{{ 'refId' | translate }}</th>
                            <th>{{ 'transactionOn' | translate }}</th>
                            <th>{{ 'transactionStatus' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="gradeX" *ngFor="let pay of onlineFeeCollection">
                            <td>{{ pay.studentName }}</td>
                            <td>
                              {{
                              pay.registrationId ? pay.registrationId : "-"
                              }}
                            </td>
                            <td>{{ pay.parentName }}</td>
                            <td>
                              {{ pay.classNumber }} - {{ pay.classDivision }}
                            </td>
                            <td>₹{{ pay.Amount }}</td>
                            <td>{{ pay.Purpose }}</td>
                            <td>{{ pay.PaymentId ? pay.PaymentId : "-" }}</td>
                            <td>{{ pay.PaymentRequestOn | date : "yMMMd" }}</td>
                            <td>
                              {{
                              pay.PaymentStatus
                              ? pay.PaymentStatus
                              : "Pending"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--end .table-responsive -->
                  </div>

                  <div class="tab-pane" id="fourth1">
                    <div class="col-md-12" style="padding: 0">
                      <div>
                        <div class="col-md-12 card-body" style="padding: 0px 15px">
                          <div class="row card" style="padding: 10px 10px 0px 10px">
                            <div class="col-md-6 hidden-sm hidden-xs" style="
                                border: 1px solid #d8d8d8;
                                padding: 10px 10px;
                              ">
                              <h3 style="
                                  display: inline-block;
                                  margin: 0;
                                  margin-right: 15px;
                                ">
                                <i class="fa fa-android" style="
                                    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                                    border: 1px solid #d6d6d6;
                                    color: #8bc34a;
                                    padding: 20px 25px;
                                    font-size: 2em;
                                    border-radius: 50%;
                                  "></i>
                              </h3>
                              <h2 class="lead" style="display: inline-block">
                                {{ 'bluewingsStaffAppVersion' | translate:{ brandName: brand.name } }}
                                <span style="font-weight: 500; color: #8bc34a">{{ 'v' | translate }} {{ staffAppAndroidVersion }}</span>
                              </h2>
                            </div>
                            <div class="col-md-6" style="padding: 5px 15px">
                              <strong>{{ activeStaffAppUser }}</strong> {{ 'activeStaffs' | translate }}
                              <span class="pull-right text-success text-sm">
                                <i class="md md-trending-up"></i></span>
                              <div class="progress progress-hairline">
                                <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                              </div>

                              {{ inActiveStaffAppUser }} {{ 'inactiveStaffs' | translate }}
                              <span class="pull-right text-danger text-sm">
                                <i class="md md-trending-down"></i></span>
                              <div class="progress progress-hairline">
                                <div class="progress-bar progress-bar-danger" style="width: 43%"></div>
                              </div>
                            </div>
                          </div>

                          <div class="row card" style="padding: 10px 10px 0px 10px">
                            <div class="col-md-6 hidden-sm hidden-xs" style="
                                border: 1px solid #d8d8d8;
                                padding: 10px 10px;
                              ">
                              <h3 style="
                                  display: inline-block;
                                  margin: 0;
                                  margin-right: 15px;
                                ">
                                <i class="fa fa-android" style="
                                    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);
                                    border: 1px solid #d6d6d6;
                                    color: #8bc34a;
                                    padding: 20px 25px;
                                    font-size: 2em;
                                    border-radius: 50%;
                                  "></i>
                              </h3>
                              <h2 class="lead" style="display: inline-block">
                                {{ 'bluewingsParentAppVersion' | translate:{ brandName: brand.name } }}
                                <span style="font-weight: 500; color: #8bc34a">{{ 'v' | translate }} {{ parentAppAndroidVersion }}</span>
                              </h2>
                            </div>
                            <div class="col-md-6" style="padding: 5px 15px">
                              <strong>{{ activeParentAppUser }}</strong> {{ 'activeParents' | translate }}
                              <span class="pull-right text-success text-sm">
                                <i class="md md-trending-up"></i></span>
                              <div class="progress progress-hairline">
                                <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                              </div>

                              {{ inActiveParentAppUser }} {{ 'inactiveParents' | translate }}
                              <span class="pull-right text-danger text-sm">
                                <i class="md md-trending-down"></i></span>
                              <div class="progress progress-hairline">
                                <div class="progress-bar progress-bar-danger" style="width: 43%"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
            </div>
            <!--end .col -->
          </div>
          <!--<em class="text-caption">Activity tabs </em>-->

          <!-- User status -->
          <div class="row hidden">
            <div class="col-md-4">
              <div class="col-md-12 card">
                <div class="card-head">
                  <header style="padding: 0px 24px">{{ 'peopleStatus' | translate }}</header>
                  <div class="col-md-12 text-sm text-default-light" style="padding: 0px 24px">
                    <p style="line-height: 15px">
                      <i class="md md-mode-comment text-primary-light"
                        style="margin-bottom: 5px; margin-right: 10px"></i>{{ 'availableStaffsStudentsStatus' | translate }}
                    </p>
                  </div>
                </div>
                <div class="card-body height-8">
                  <strong>214</strong> {{ 'activeStaffs' | translate }}
                  <span class="pull-right text-success text-sm">
                    <i class="md md-trending-up"></i></span>
                  <div class="progress progress-hairline">
                    <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                  </div>

                  291 {{ 'inactiveStaffs' | translate }}
                  <span class="pull-right text-danger text-sm">
                    <i class="md md-trending-down"></i></span>
                  <div class="progress progress-hairline">
                    <div class="progress-bar progress-bar-danger" style="width: 43%"></div>
                  </div>

                  756 {{ 'activeParents' | translate }}
                  <span class="pull-right text-success text-sm">
                    <i class="md md-trending-up"></i></span>
                  <div class="progress progress-hairline">
                    <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                  </div>

                  291 {{ 'inactiveParents' | translate }}
                  <span class="pull-right text-danger text-sm">
                    <i class="md md-trending-down"></i></span>
                  <div class="progress progress-hairline">
                    <div class="progress-bar progress-bar-danger" style="width: 47%"></div>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
            </div>
            <!--end .col -->

            <div class="col-md-8">
              <div class="col-md-12 card"></div>
            </div>
          </div>

          <div class="row hidden">
            <div class="col-md-12">
              <div class="card">
                <div class="card-head">
                  <header>{{ 'registrationHistory' | translate }}</header>
                  <div class="tools">
                    <a class="btn btn-icon-toggle btn-refresh"><i class="md md-refresh"></i></a>
                    <!-- <a class="btn btn-icon-toggle btn-collapse"><i class="fa fa-angle-down"></i></a>
                                        <a class="btn btn-icon-toggle btn-close"><i class="md md-close"></i></a> -->
                  </div>
                </div>
                <!--end .card-head -->
                <div class="card-body no-padding height-9">
                  <div class="row">
                    <div class="col-sm-6 hidden-xs">
                      <div class="force-padding text-sm text-default-light">
                        <p>
                          <i class="md md-mode-comment text-primary-light"></i>
                          {{ 'loremIpsumDolorSitAmetConsecteturAdipisicing' | translate }}
                          {{ 'elitSedDoEiusmodTemporIncididuntUtLaboreEt' | translate }}
                          {{ 'doloreMagnaAliqua' | translate }}
                        </p>
                      </div>
                    </div>
                    <!--end .col -->
                    <div class="col-sm-6">
                      <div class="force-padding pull-right text-default-light">
                        <h2 class="no-margin text-primary-dark">
                          <span class="text-xxl">66.05%</span>
                        </h2>
                        <i class="fa fa-caret-up text-success fa-fw"></i> {{ 'more' | translate }}
                        {{ 'registrations' | translate }}
                      </div>
                    </div>
                    <!--end .col -->
                  </div>
                  <!--end .row -->
                  <div class="stick-bottom-left-right force-padding">
                    <div id="flot-registrations" class="flot height-5" data-title="Registration history"
                      data-color="#0aa89e"></div>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END REGISTRATION HISTORY -->
          </div>
          <!--end .row -->
          <div class="row hidden">
            <!-- BEGIN SITE ACTIVITY -->
            <div class="col-md-6">
              <div class="card">
                <div class="row">
                  <div class="col-md-8 hidden">
                    <div class="card-head">
                      <header>{{ 'feesCollected' | translate }}</header>
                    </div>
                    <!--end .card-head -->
                    <div class="card-body height-8">
                      <!-- <div id="flot-visitors-legend" class="flot-legend-horizontal stick-top-right no-y-padding"></div> -->
                      <div id="flot-visitors" class="flot height-7" data-title="Activity entry"
                        data-color="#7dd8d2,#0aa89e"></div>
                    </div>
                    <!--end .card-body -->
                  </div>
                  <!--end .col -->
                  <div class="col-md-12">
                    <div class="card-head">
                      <header>{{ 'peopleStatus' | translate }}</header>
                    </div>
                    <div class="card-body height-8">
                      <strong>214</strong> {{ 'activeStaffs' | translate }}
                      <span class="pull-right text-success text-sm">0,18% <i class="md md-trending-up"></i></span>
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                      </div>

                      291 {{ 'inactiveStaffs' | translate }}
                      <span class="pull-right text-danger text-sm">21,08% <i class="md md-trending-down"></i></span>
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-danger" style="width: 43%"></div>
                      </div>

                      756 {{ 'activeParents' | translate }}
                      <span class="pull-right text-success text-sm">0,68% <i class="md md-trending-up"></i></span>
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-primary-dark" style="width: 11%"></div>
                      </div>

                      291 {{ 'inactiveParents' | translate }}
                      <span class="pull-right text-danger text-sm">21,08% <i class="md md-trending-down"></i></span>
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-danger" style="width: 47%"></div>
                      </div>
                    </div>
                    <!--end .card-body -->
                  </div>
                  <!--end .col -->
                </div>
                <!--end .row -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END SITE ACTIVITY -->

            <!-- BEGIN NEW REGISTRATIONS -->
            <div class="col-md-3 hidden">
              <div class="card">
                <div class="card-head">
                  <header>{{ 'newRegistrations' | translate }}</header>
                  <div class="tools hidden-md">
                    <a class="btn btn-icon-toggle btn-close"><i class="md md-close"></i></a>
                  </div>
                </div>
                <!--end .card-head -->
                <div class="card-body no-padding height-9 scroll">
                  <ul class="list divider-full-bleed">
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar9.jpg?1404026744" alt="" />
                        </div>
                        <div class="tile-text">{{ 'annLaurens' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar4.jpg?1404026791" alt="" />
                        </div>
                        <div class="tile-text">{{ 'alexNelson' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar11.jpg?1404026774" alt="" />
                        </div>
                        <div class="tile-text">{{ 'maryPeterson' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar7.jpg?1404026721" alt="" />
                        </div>
                        <div class="tile-text">{{ 'philipEricsson' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar8.jpg?1404026729" alt="" />
                        </div>
                        <div class="tile-text">{{ 'jimPeters' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                    <li class="tile">
                      <div class="tile-content">
                        <div class="tile-icon">
                          <img src="assets/img/avatar2.jpg?1404026449" alt="" />
                        </div>
                        <div class="tile-text">{{ 'jessicaCruise' | translate }}</div>
                      </div>
                      <a class="btn btn-flat ink-reaction">
                        <i class="md md-block text-default-light"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END NEW REGISTRATIONS -->

            <!-- BEGIN TODOS -->
            <div class="col-md-3 broadcast-recent">
              <div class="card">
                <div class="card-head" style="background: #0aa89e; color: white">
                  <header>{{ 'recentBroadcasts' | translate }}</header>
                  <!-- <div class="tools">
                                        <a class="btn btn-icon-toggle btn-close"><i class="md md-close"></i></a>
                                    </div> -->
                </div>
                <!--end .card-head -->
                <div class="card-body no-padding height-9 scroll">
                  <ul class="list" data-sortable="true">
                    <li class="tile">
                      <div class="checkbox checkbox-styled tile-text">
                        <label style="padding-bottom: 0">
                          <span style="font-size: 13px">{{ 'loremIpsumDolorSitAmetConsectetur' | translate }}</span><br />
                          <p style="font-size: 10px; color: #9e9e9e">
                            {{ 'byManager' | translate }}
                          </p>
                        </label>
                      </div>
                      <button style="
                          margin: 0px 10px;
                          background: #0aa89e;
                          border: 1px solid #0aa89e;
                          width: initial;
                          min-width: 45px;
                        " type="button" class="btn ink-reaction btn-floating-action btn-primary">
                        <i class="md md-done-all"></i>
                      </button>
                    </li>
                    <li class="tile">
                      <div class="checkbox checkbox-styled tile-text">
                        <label style="padding-bottom: 0">
                          <span style="font-size: 13px">{{ 'loremIpsumDolorSitAmetConsectetur' | translate }}</span><br />
                          <p style="font-size: 10px; color: #9e9e9e">
                            {{ 'byManager' | translate }}
                          </p>
                        </label>
                      </div>
                      <button style="
                          margin: 0px 10px;
                          background: #f44336;
                          border: 1px solid #f44336;
                          width: initial;
                          min-width: 45px;
                        " type="button" class="btn ink-reaction btn-floating-action btn-primary">
                        <i class="md md-clear"></i>
                      </button>
                    </li>
                    <li class="tile">
                      <div class="checkbox checkbox-styled tile-text">
                        <label style="padding-bottom: 0">
                          <span style="font-size: 13px">{{ 'loremIpsumDolorSitAmetConsectetur' | translate }}</span><br />
                          <p style="font-size: 10px; color: #9e9e9e">
                            {{ 'byManager' | translate }}
                          </p>
                        </label>
                      </div>
                      <button style="
                          margin: 0px 10px;
                          background: #0aa89e;
                          border: 1px solid #0aa89e;
                          width: initial;
                          min-width: 45px;
                        " type="button" class="btn ink-reaction btn-floating-action btn-primary">
                        <i class="md md-done-all"></i>
                      </button>
                    </li>
                  </ul>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->

            <!-- BEGIN SERVER STATUS -->
            <div class="col-md-3">
              <div class="card">
                <div class="card-head">
                  <header class="text-primary">{{ 'serverStatus' | translate }}</header>
                </div>
                <!--end .card-head -->
                <div class="card-body height-4">
                  <div class="pull-right text-center">
                    <em class="text-primary">{{ 'temperature' | translate }}</em>
                    <br />
                    <div id="serverStatusKnob" class="knob knob-shadow knob-primary knob-body-track size-2">
                      <input type="text" class="dial" data-min="0" data-max="100" data-thickness=".09" value="50"
                        data-readOnly="true" />
                    </div>
                  </div>
                </div>
                <!--end .card-body -->
                <div class="card-body height-4 no-padding">
                  <div class="stick-bottom-left-right">
                    <div id="rickshawGraph" class="height-4" data-color1="#0aa89e" data-color2="rgba(79, 89, 89, 0.2)">
                    </div>
                  </div>
                </div>
                <!--end .card-body -->
              </div>
              <!--end .card -->
            </div>
            <!--end .col -->
            <!-- END SERVER STATUS -->
          </div>
          <!--end .row -->
        </div>
        <!--end .section-body -->
      </section>
    </div>
    <!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->

    <div class="offcanvas">
      <!--View Activity offcanvas -->
      <div id="offcanvas-view-activity" class="offcanvas-pane width-12" style="width: 1000px; overflow-x: hidden">
        <div class="offcanvas-head" style="padding: 0">
          <div class="particles-bg row" style="background: var(--secondary-btn-bg-color); min-height: 250px">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed; z-index: 999; top: 0em">
                <h3 class="pull-right" style="color: white; cursor: pointer" data-dismiss="offcanvas">
                  <i class="fa fa-close"></i>
                </h3>
              </div>
              <div class="col-md-12 text-center">
                <p class="lead text-center" style="
                    color: #ffffff;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    margin-bottom: 10px;
                  ">
                  {{ 'schoolActivities' | translate }}                
                </p>
                <img src="assets/img/activities.png" class="img-responsive" style="margin: 0 auto; width: 75px" />
                <p style="margin: 15px 0px; color: white; font-weight: 100">
                  {{ 'viewSelectedClassActivityDetailsHere' | translate }}
                </p>
                <p class="lead" style="
                    color: white;
                    font-size: 15px;
                    border: 1px solid;
                    display: inline-block;
                    padding: 5px 15px;
                    font-weight: 500;
                  ">
                  {{ viewActivityClassNumber }} - {{ viewActivityClassSection }}
                </p>
              </div>
            </div>
          </div>

          <div class="row" style="background: #f1f1f1">
            <div class="col-md-12">
              <h4 class="lead pull-left" style="
                  margin: 10px 10px;
                  color: #888888;
                  letter-spacing: 1px;
                  font-size: 12px;
                  text-transform: uppercase;
                ">
                  {{ 'classActivityDetails' | translate }}              
                </h4>
              <!-- 	<div>
                                <h2 class="lead" style="margin: 5px;background: #a0a0a0;color: white;padding: 1em 2em;position: absolute;    float: right !important;">
                                    <span><i class="fa fa-shield"></i></span>
                                    <span>LKG</span>
                                    <span>A</span>
                                </h2>
                                </div> -->
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs tabs-center" data-toggle="tabs" style="cursor: pointer">
                <li class="active">
                  <a data-target="#classoverview" data-toggle="tab">{{ 'classOverview' | translate }}</a>
                </li>
                <!-- <li><a href="#conversations">Conversations</a></li> -->
                <li>
                  <a data-target="#activities" data-toggle="tab">{{ 'activityPosted' | translate }}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="card-body tab-content" style="padding: 20px 0px; padding-bottom: 0">
            <div class="tab-pane active" id="classoverview">
              <div class="row" style="margin: 0">
                <div class="row" style="margin: 0; margin-bottom: 3em">
                  <div class="col-md-3" style="text-align: center">
                    <div class="col-md-12 card height-2" style="background: #fdfdfd">
                      <p style="
                          text-align: left;
                          margin-top: 10px;
                          text-transform: capitalize;
                          color: #9a9a9a;
                          border-bottom: 1px solid #f3f3f3;
                          font-weight: 100;
                        ">
                        <i class="fa fa-users"></i> {{ 'students' | translate }}
                      </p>
                      <div class="card" style="
                          border-bottom: 2px solid #f44336;
                          text-align: center;
                          background: #ffffff;
                        ">
                        <h2 style="
                            text-align: left;
                            color: #636363;
                            line-height: 20px;
                            display: inline-block;
                            margin: 10px;
                            font-size: 20px;
                          ">
                          {{ viewActivityTotalStudent }}<br /><span style="
                              font-size: 13px;
                              background: #f44336;
                              color: white;
                              padding: 0px 10px;
                              font-weight: 100;
                            ">{{ 'totalCount' | translate }}</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3" style="text-align: center">
                    <div class="col-md-12 card height-2" style="background: #fdfdfd">
                      <p style="
                          text-align: left;
                          margin-top: 10px;
                          text-transform: capitalize;
                          color: #9a9a9a;
                          border-bottom: 1px solid #f3f3f3;
                          font-weight: 100;
                        ">
                        <i class="fa fa-check-square-o"></i> {{ 'attendance' | translate }}
                      </p>
                      <div class="card" style="
                          border-bottom: 2px solid #ff9800;
                          text-align: center;
                          background: #ffffff;
                        ">
                        <!-- <h1 style="display: inline-block;margin: 0;font-size: 4em;color: #808080;padding: 0px 15px;"><i class="fa fa-check-square-o"></i></h1> -->
                        <h2 style="
                            text-align: left;
                            color: #636363;
                            line-height: 20px;
                            display: inline-block;
                            margin: 10px;
                            font-size: 20px;
                          ">
                          {{ viewActivityAttendence }}/{{
                          viewActivityTotalStudent
                          }}<br /><span style="
                              font-size: 13px;
                              background: #ff9800;
                              color: white;
                              font-weight: 100;
                              padding: 0px 10px;
                            ">{{ 'strength' | translate }}</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3" style="text-align: center">
                    <div class="col-md-12 card height-2" style="background: #fdfdfd">
                      <p style="
                          text-align: left;
                          margin-top: 10px;
                          text-transform: capitalize;
                          color: #9a9a9a;
                          border-bottom: 1px solid #f3f3f3;
                          font-weight: 100;
                        ">
                        <i class="fa fa-money"></i> {{ 'feesCollected' | translate }}
                      </p>
                      <div class="card" style="
                          border-bottom: 2px solid #8bc34a;
                          text-align: center;
                          background: #ffffff;
                        ">
                        <!-- <h1 style="display: inline-block;margin: 0;font-size: 4em;color: #808080;padding: 0px 15px;"><i class="fa fa-money"></i></h1> -->
                        <h2 style="
                            text-align: left;
                            color: #636363;
                            line-height: 20px;
                            display: inline-block;
                            margin: 10px;
                            font-size: 20px;
                          ">
                          {{ 'rs' | translate }}. {{ viewActivityFeesCollected || 0 }}<br /><span style="
                              font-size: 13px;
                              background: #8bc34a;
                              color: white;
                              padding: 0px 10px;
                              font-weight: 100;
                            ">{{ 'collected' | translate }}</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3" style="text-align: center">
                    <div class="col-md-12 card height-2" style="background: #fdfdfd">
                      <p style="
                          text-align: left;
                          margin-top: 10px;
                          text-transform: capitalize;
                          color: #9a9a9a;
                          border-bottom: 1px solid #f3f3f3;
                          font-weight: 100;
                        ">
                        <i class="fa fa-file-o"></i> {{ 'diaries' | translate }}
                      </p>
                      <div class="card" style="
                          border-bottom: 2px solid #9e9e9e;
                          text-align: center;
                          background: #ffffff;
                        ">
                        <!-- <h1 style="display: inline-block;margin: 0;font-size: 4em;color: #808080;padding: 0px 15px;"><i class="fa fa-file-o"></i></h1> -->
                        <h2 style="
                            text-align: left;
                            color: #636363;
                            line-height: 20px;
                            display: inline-block;
                            margin: 10px;
                            font-size: 20px;
                          ">
                          {{ viewActivityDiaries }}<br /><span style="
                              font-size: 13px;
                              background: #9e9e9e;
                              color: white;
                              padding: 0px 10px;
                              font-weight: 100;
                            ">{{ 'notes' | translate }}</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="col-md-12 card height-6" style="background: #fdfdfd; margin-bottom: 0"
                      style="overflow: auto">
                      <p style="
                          text-align: left;
                          margin-top: 10px;
                          text-transform: capitalize;
                          color: #9a9a9a;
                          border-bottom: 1px solid #f3f3f3;
                          font-weight: 100;
                        ">
                        <i class="fa fa-user"></i> {{ 'classTeachers' | translate }}
                      </p>
                      <ul *ngIf="
                          viewActivityTeacher1 &&
                          viewActivityTeacher2 &&
                          viewActivityTeacher3
                        " class="list divider-full-bleed">
                        <li class="tile" *ngIf="viewActivityTeacher1">
                          <a class="tile-content ink-reaction" style="color: #868686">
                            <!-- <div class="tile-icon">
                                                                <h3 style="margin: 0;"><i class="fa fa-user"></i></h3>
                                                            </div> -->
                            <div class="tile-text">
                              {{ viewActivityTeacher1 }}
                            </div>
                          </a>
                          <a class="disabled btn btn-flat ink-reaction hide" style="color: var(--secondary-btn-bg-color); opacity: inherit"><i
                              class="fa fa-circle-o"></i></a>
                        </li>
                        <li class="tile" *ngIf="viewActivityTeacher2">
                          <a class="tile-content ink-reaction" style="color: #868686">
                            <!-- <div class="tile-icon">
                                                                <h3 style="margin: 0;"><i class="fa fa-user"></i></h3>
                                                            </div> -->
                            <div class="tile-text">
                              {{ viewActivityTeacher2 }}
                            </div>
                          </a>
                          <a class="disabled btn btn-flat ink-reaction hide" style="color: var(--secondary-btn-bg-color); opacity: inherit"><i
                              class="fa fa-circle-o"></i></a>
                        </li>
                        <li class="tile" *ngIf="viewActivityTeacher3">
                          <a class="tile-content ink-reaction" style="color: #868686">
                            <!-- <div class="tile-icon">
                                                                <h3 style="margin: 0;"><i class="fa fa-user"></i></h3>
                                                            </div> -->
                            <div class="tile-text">
                              {{ viewActivityTeacher3 }}
                            </div>
                          </a>
                          <a class="disabled btn btn-flat ink-reaction hide" style="color: var(--secondary-btn-bg-color); opacity: inherit"><i
                              class="fa fa-circle-o"></i></a>
                        </li>
                      </ul>
                      <div *ngIf="
                          !(
                            viewActivityTeacher1 &&
                            viewActivityTeacher2 &&
                            viewActivityTeacher3
                          )
                        ">
                        {{ 'thereAreNoClassTeachers' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="conversations">{{ 'conversation' | translate }}</div>
            <div class="tab-pane" id="activities">
              <div *ngIf="!feedCount" class="col-md-12" style="
                  text-align: center;
                  background: url('assets/img/noresult.jpg');
                  background-size: contain;
                  background-position: -10px 4px;
                  color: #909090;
                ">
                <div class="col-md-12" style="min-height: 300px; padding-top: 4em">
                  <h1 style="font-size: 4em">
                    <i class="fa fa-file-excel-o"></i>
                  </h1>
                  <h3>{{ 'noResults' | translate }}</h3>
                  <p>
                   {{ 'weSearchForAndWideAndCouldntFindAnyFilesMatching' | translate }}
                  </p>
                </div>
              </div>

              <div *ngIf="feedCount" class="col-md-12 card" style="padding: 0">
                <div class="row card" *ngFor="let feed of getgetClassFeedListArray"
                  style="margin-top: 2em; margin-bottom: 1em">
                  <div class="col-md-6" style="
                      padding: 10px 10px;
                      border-right: 1px solid #e2e2e2;
                      padding-left: 20px;
                    " *ngIf="feed.media.length">
                    <img class="img-responsive" style="height: 300px; width: 470px"
                      src="{{ feed.media[0].MediaUrl }}" />
                    <!--<img *ngIf = !feed.media.length class="img-responsive" src="assets/img/activitydefault.jpg">-->
                  </div>
                  <div class="col-md-6">
                    <ul class="list">
                      <li class="tile">
                        <a class="tile-content ink-reaction" style="color: #717171">
                          <div class="tile-icon">
                            <i class="glyphicon glyphicon-user"></i>
                          </div>
                          <div class="tile-text" style="font-size: 13px">
                            {{ feed.staffName }}
                            <small style="font-size: 11px">
                              {{ feed.designation }}
                              <span style="margin-left: 10px; color: black"><i class="fa fa-clock-o"></i>
                                {{ feed.CreatedOn | date : "yMMMd" }}</span>
                            </small>
                          </div>
                          <p style="font-size: 12px">{{ feed.Description }}</p>

                          <div>
                            <h5 style="
                                display: inline-block;
                                margin: 0px 10px;
                                background: #ababab;
                                color: white;
                                padding: 2px 15px;
                                border-radius: 10px;
                              ">
                              <i class="fa fa-thumbs-o-up"></i><span style="margin-left: 5px">{{
                                feed.TotalLikesCount
                                }}</span>
                              {{ 'likes' | translate }}
                            </h5>
                            <h5 style="
                                display: inline-block;
                                margin: 0px 10px;
                                background: #ababab;
                                color: white;
                                padding: 2px 15px;
                                border-radius: 10px;
                              ">
                              <i class="fa fa-comment-o"></i><span style="margin-left: 5px">{{
                                feed.TotalCommentsCount
                                }}</span>
                              {{ 'comments' | translate }}
                            </h5>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End view student off canvas -->
    </div>
  </div>
  <!--end #base-->
  <!-- END BASE -->
</div>